export const NAMES_DATA = [
  { text: 'Karin', sex: 'f' },
  { text: 'Karína', sex: 'f' },
  { text: 'Radmila', sex: 'f' },
  { text: 'Diana', sex: 'f' },
  { text: 'Karina', sex: 'f' },
  { text: 'Dalimil', sex: 'm' },
  { text: 'Dalemil', sex: 'm' },
  { text: 'Melichar', sex: 'm' },
  { text: 'Baltazar', sex: 'm' },
  { text: 'Kašpar', sex: 'm' },
  { text: 'Wilhelmina', sex: 'f' },
  { text: 'Vilma', sex: 'f' },
  { text: 'Čestmír', sex: 'm' },
  { text: 'Vladan', sex: 'm' },
  { text: 'Břetislav', sex: 'm' },
  { text: 'Bohdana', sex: 'f' },
  { text: 'Pravoslav', sex: 'm' },
  { text: 'Edita', sex: 'f' },
  { text: 'Radovan', sex: 'm' },
  { text: 'Alice', sex: 'f' },
  { text: 'Česlav', sex: 'm' },
  { text: 'Ctirad', sex: 'm' },
  { text: 'Drahoslav', sex: 'm' },
  { text: 'Vladislav', sex: 'm' },
  { text: 'Doubravka', sex: 'f' },
  { text: 'Ilona', sex: 'f' },
  { text: 'Běla', sex: 'f' },
  { text: 'Slavomír', sex: 'm' },
  { text: 'Zdenko', sex: 'm' },
  { text: 'Zdeněk', sex: 'm' },
  { text: 'Zdenek', sex: 'm' },
  { text: 'Milena', sex: 'f' },
  { text: 'Miloš', sex: 'm' },
  { text: 'Zora', sex: 'f' },
  { text: 'Ingrid', sex: 'f' },
  { text: 'Otýlie', sex: 'f' },
  { text: 'Otilie', sex: 'f' },
  { text: 'Zdeslava', sex: 'f' },
  { text: 'Zdislava', sex: 'f' },
  { text: 'Robin', sex: 'm' },
  { text: 'Marika', sex: 'f' },
  { text: 'Hynek', sex: 'm' },
  { text: 'Nela', sex: 'f' },
  { text: 'Blažej', sex: 'm' },
  { text: 'Jarmila', sex: 'f' },
  { text: 'Dobromila', sex: 'f' },
  { text: 'Vanda', sex: 'f' },
  { text: 'Wanda', sex: 'f' },
  { text: 'Veronika', sex: 'f' },
  { text: 'Milada', sex: 'f' },
  { text: 'Apolena', sex: 'f' },
  { text: 'Mojmír', sex: 'm' },
  { text: 'Božena', sex: 'f' },
  { text: 'Slavěna', sex: 'f' },
  { text: 'Věnceslav', sex: 'm' },
  { text: 'Valentýn', sex: 'm' },
  { text: 'Valentin', sex: 'm' },
  { text: 'Valentýna', sex: 'f' },
  { text: 'Jiřina', sex: 'f' },
  { text: 'Jorga', sex: 'f' },
  { text: 'Ljuba', sex: 'f' },
  { text: 'Miloslava', sex: 'f' },
  { text: 'Gisela', sex: 'f' },
  { text: 'Gizela', sex: 'f' },
  { text: 'Patrik', sex: 'm' },
  { text: 'Oldřich', sex: 'm' },
  { text: 'Lenka', sex: 'f' },
  { text: 'Eleonora', sex: 'f' },
  { text: 'Petr', sex: 'm' },
  { text: 'Svatopluk', sex: 'm' },
  { text: 'Matyáš', sex: 'm' },
  { text: 'Matěj', sex: 'm' },
  { text: 'Matej', sex: 'm' },
  { text: 'Lilian', sex: 'm' },
  { text: 'Lily', sex: 'f' },
  { text: 'Liliana', sex: 'f' },
  { text: 'Dorota', sex: 'f' },
  { text: 'Dorotea', sex: 'f' },
  { text: 'Alexander', sex: 'm' },
  { text: 'Alexis', sex: 'm' },
  { text: 'Alexandr', sex: 'm' },
  { text: 'Lumír', sex: 'm' },
  { text: 'Rufin', sex: 'm' },
  { text: 'Horymír', sex: 'm' },
  { text: 'Bedřich', sex: 'm' },
  { text: 'Anežka', sex: 'f' },
  { text: 'Ines', sex: 'f' },
  { text: 'Agnes', sex: 'f' },
  { text: 'Kamil', sex: 'm' },
  { text: 'Stela', sex: 'f' },
  { text: 'Stella', sex: 'f' },
  { text: 'Kazimír', sex: 'm' },
  { text: 'Mirek', sex: 'm' },
  { text: 'Miroslav', sex: 'm' },
  { text: 'Thomas', sex: 'm' },
  { text: 'Tom', sex: 'm' },
  { text: 'Tomáš', sex: 'm' },
  { text: 'Gabriela', sex: 'f' },
  { text: 'Francesca', sex: 'f' },
  { text: 'Františka', sex: 'f' },
  { text: 'Viktorie', sex: 'f' },
  { text: 'Angelina', sex: 'f' },
  { text: 'Andělína', sex: 'f' },
  { text: 'Anděla', sex: 'f' },
  { text: 'Gregor', sex: 'm' },
  { text: 'Řehoř', sex: 'm' },
  { text: 'Rosita', sex: 'f' },
  { text: 'Růžena', sex: 'f' },
  { text: 'Rozálie', sex: 'f' },
  { text: 'Matylda', sex: 'f' },
  { text: 'Rút', sex: 'f' },
  { text: 'Rut', sex: 'f' },
  { text: 'Ida', sex: 'f' },
  { text: 'Elena', sex: 'f' },
  { text: 'Herbert', sex: 'm' },
  { text: 'Vlastimil', sex: 'm' },
  { text: 'Eduard', sex: 'm' },
  { text: 'Edvard', sex: 'm' },
  { text: 'Jozef', sex: 'm' },
  { text: 'Josef', sex: 'm' },
  { text: 'Světlana', sex: 'f' },
  { text: 'Radomil', sex: 'm' },
  { text: 'Radek', sex: 'm' },
  { text: 'Leona', sex: 'f' },
  { text: 'Ivona', sex: 'f' },
  { text: 'Yvona', sex: 'f' },
  { text: 'Gabriel', sex: 'm' },
  { text: 'Marián', sex: 'm' },
  { text: 'Marius', sex: 'm' },
  { text: 'Marian', sex: 'm' },
  { text: 'Emanuel', sex: 'm' },
  { text: 'Dita', sex: 'f' },
  { text: 'Ditta', sex: 'f' },
  { text: 'Sonja', sex: 'f' },
  { text: 'Sonia', sex: 'f' },
  { text: 'Soňa', sex: 'f' },
  { text: 'Taťána', sex: 'f' },
  { text: 'Tatiana', sex: 'f' },
  { text: 'Arnošt', sex: 'm' },
  { text: 'Kvido', sex: 'm' },
  { text: 'Quido', sex: 'm' },
  { text: 'Hugo', sex: 'm' },
  { text: 'Erika', sex: 'f' },
  { text: 'Richard', sex: 'm' },
  { text: 'Ivana', sex: 'f' },
  { text: 'Ivanka', sex: 'f' },
  { text: 'Miroslava', sex: 'f' },
  { text: 'Mirka', sex: 'f' },
  { text: 'Vendulka', sex: 'f' },
  { text: 'Vendula', sex: 'f' },
  { text: 'Herman', sex: 'm' },
  { text: 'Hermína', sex: 'f' },
  { text: 'Heřman', sex: 'm' },
  { text: 'Ema', sex: 'f' },
  { text: 'Emma', sex: 'f' },
  { text: 'Dušan', sex: 'm' },
  { text: 'Dušana', sex: 'm' },
  { text: 'Daria', sex: 'f' },
  { text: 'Darya', sex: 'f' },
  { text: 'Darja', sex: 'f' },
  { text: 'Isabel', sex: 'f' },
  { text: 'Izabela', sex: 'f' },
  { text: 'Julius', sex: 'm' },
  { text: 'Julian', sex: 'm' },
  { text: 'Július', sex: 'm' },
  { text: 'Aleš', sex: 'm' },
  { text: 'Vincenc', sex: 'm' },
  { text: 'Vincent', sex: 'm' },
  { text: 'Anastázie', sex: 'f' },
  { text: 'Anastazia', sex: 'f' },
  { text: 'Irini', sex: 'f' },
  { text: 'Irena', sex: 'f' },
  { text: 'Rolf', sex: 'm' },
  { text: 'Rudolf', sex: 'm' },
  { text: 'Valérie', sex: 'f' },
  { text: 'Valerie', sex: 'f' },
  { text: 'Valeria', sex: 'f' },
  { text: 'Rostislava', sex: 'm' },
  { text: 'Marcela', sex: 'f' },
  { text: 'Alexandra', sex: 'f' },
  { text: 'Evženie', sex: 'f' },
  { text: 'Evžénie', sex: 'f' },
  { text: 'Vojtěch', sex: 'm' },
  { text: 'Juraj', sex: 'm' },
  { text: 'George', sex: 'm' },
  { text: 'Jiří', sex: 'm' },
  { text: 'Marek', sex: 'm' },
  { text: 'Ota', sex: 'm' },
  { text: 'Otto', sex: 'm' },
  { text: 'Oto', sex: 'm' },
  { text: 'Jaroslav', sex: 'm' },
  { text: 'Vlastislav', sex: 'm' },
  { text: 'Robert', sex: 'm' },
  { text: 'Blahoslav', sex: 'm' },
  { text: 'Zikmund', sex: 'm' },
  { text: 'Alex', sex: 'm' },
  { text: 'Alexej', sex: 'm' },
  { text: 'Květoslav', sex: 'm' },
  { text: 'Klaudia', sex: 'f' },
  { text: 'Claudia', sex: 'f' },
  { text: 'Klaudie', sex: 'f' },
  { text: 'Radoslav', sex: 'm' },
  { text: 'Stanislav', sex: 'm' },
  { text: 'Ctibor', sex: 'm' },
  { text: 'Stibor', sex: 'm' },
  { text: 'Blažena', sex: 'f' },
  { text: 'Svatava', sex: 'f' },
  { text: 'Pankrác', sex: 'm' },
  { text: 'Servác', sex: 'm' },
  { text: 'Bonifác', sex: 'm' },
  { text: 'Žofie', sex: 'f' },
  { text: 'Přemysl', sex: 'm' },
  { text: 'Anetta', sex: 'f' },
  { text: 'Aneta', sex: 'f' },
  { text: 'Nataša', sex: 'f' },
  { text: 'Ivo', sex: 'm' },
  { text: 'Ivoš', sex: 'm' },
  { text: 'Zbyšek', sex: 'm' },
  { text: 'Monika', sex: 'f' },
  { text: 'Emil', sex: 'm' },
  { text: 'Vladimír', sex: 'm' },
  { text: 'Jana', sex: 'f' },
  { text: 'Viola', sex: 'f' },
  { text: 'Filip', sex: 'm' },
  { text: 'Waldemar', sex: 'm' },
  { text: 'Valdemar', sex: 'm' },
  { text: 'Vilém', sex: 'm' },
  { text: 'Maxmilian', sex: 'm' },
  { text: 'Maxmilián', sex: 'm' },
  { text: 'Maximilian', sex: 'm' },
  { text: 'Ferdinand', sex: 'm' },
  { text: 'Kamila', sex: 'm' },
  { text: 'Laura', sex: 'f' },
  { text: 'Jarmil', sex: 'm' },
  { text: 'Tamara', sex: 'f' },
  { text: 'Dalibor', sex: 'm' },
  { text: 'Dobroslav', sex: 'm' },
  { text: 'Norbert', sex: 'm' },
  { text: 'Yveta', sex: 'f' },
  { text: 'Iveta', sex: 'f' },
  { text: 'Medard', sex: 'm' },
  { text: 'Stanislava', sex: 'f' },
  { text: 'Otta', sex: 'm' },
  { text: 'Bruno', sex: 'm' },
  { text: 'Antonie', sex: 'f' },
  { text: 'Antonina', sex: 'f' },
  { text: 'Antonin', sex: 'm' },
  { text: 'Antonín', sex: 'm' },
  { text: 'Roland', sex: 'm' },
  { text: 'Vít', sex: 'm' },
  { text: 'Vítek', sex: 'm' },
  { text: 'Zbyněk', sex: 'm' },
  { text: 'Adolf', sex: 'm' },
  { text: 'Milan', sex: 'm' },
  { text: 'Leoš', sex: 'm' },
  { text: 'Květa', sex: 'f' },
  { text: 'Kveta', sex: 'f' },
  { text: 'Aloys', sex: 'm' },
  { text: 'Alojz', sex: 'm' },
  { text: 'Alois', sex: 'm' },
  { text: 'Pavla', sex: 'f' },
  { text: 'Zdenka', sex: 'f' },
  { text: 'Zdena', sex: 'f' },
  { text: 'Zdeňka', sex: 'f' },
  { text: 'Jan', sex: 'm' },
  { text: 'Ivan', sex: 'm' },
  { text: 'Adriana', sex: 'm' },
  { text: 'Ladislav', sex: 'm' },
  { text: 'Lubomil', sex: 'm' },
  { text: 'Lubomír', sex: 'm' },
  { text: 'Pavel', sex: 'm' },
  { text: 'Petr', sex: 'm' },
  { text: 'Šárka', sex: 'f' },
  { text: 'Jaroslava', sex: 'f' },
  { text: 'Patricie', sex: 'f' },
  { text: 'Radomír', sex: 'm' },
  { text: 'Prokop', sex: 'm' },
  { text: 'Metoděj', sex: 'm' },
  { text: 'Cyril', sex: 'm' },
  { text: 'Bohuslava', sex: 'f' },
  { text: 'Nora', sex: 'm' },
  { text: 'Drahoslava', sex: 'm' },
  { text: 'Amálie', sex: 'f' },
  { text: 'Libuše', sex: 'f' },
  { text: 'Olga', sex: 'f' },
  { text: 'Bořek', sex: 'm' },
  { text: 'Margit', sex: 'f' },
  { text: 'Margareta', sex: 'f' },
  { text: 'Markéta', sex: 'f' },
  { text: 'Karolina', sex: 'f' },
  { text: 'Karla', sex: 'f' },
  { text: 'Karolína', sex: 'f' },
  { text: 'Jindřich', sex: 'm' },
  { text: 'Liboslav', sex: 'm' },
  { text: 'Luboslav', sex: 'm' },
  { text: 'Luboš', sex: 'm' },
  { text: 'Martina', sex: 'f' },
  { text: 'Drahomíra', sex: 'f' },
  { text: 'Čeněk', sex: 'm' },
  { text: 'Ilja', sex: 'm' },
  { text: 'Vítězslav', sex: 'm' },
  { text: 'Magdaléna', sex: 'f' },
  { text: 'Magdalena', sex: 'f' },
  { text: 'Libor', sex: 'm' },
  { text: 'Kristina', sex: 'f' },
  { text: 'Kristýna', sex: 'f' },
  { text: 'Kristen', sex: 'm' },
  { text: 'Jakub', sex: 'm' },
  { text: 'Anna', sex: 'f' },
  { text: 'Věroslav', sex: 'm' },
  { text: 'Victor', sex: 'm' },
  { text: 'Viktor', sex: 'm' },
  { text: 'Martha', sex: 'f' },
  { text: 'Marta', sex: 'f' },
  { text: 'Bořivoj', sex: 'm' },
  { text: 'Ignác', sex: 'm' },
  { text: 'Oskar', sex: 'm' },
  { text: 'Gustav', sex: 'm' },
  { text: 'Miluše', sex: 'f' },
  { text: 'Dominik', sex: 'm' },
  { text: 'Kristián', sex: 'm' },
  { text: 'Křišťan', sex: 'm' },
  { text: 'Milivoj', sex: 'm' },
  { text: 'Oldřiška', sex: 'f' },
  { text: 'Lada', sex: 'f' },
  { text: 'Soběslav', sex: 'm' },
  { text: 'Roman', sex: 'm' },
  { text: 'Vavřinec', sex: 'm' },
  { text: 'Susana', sex: 'f' },
  { text: 'Zuzana', sex: 'f' },
  { text: 'Clara', sex: 'f' },
  { text: 'Klára', sex: 'f' },
  { text: 'Alena', sex: 'f' },
  { text: 'Alan', sex: 'm' },
  { text: 'Hanka', sex: 'f' },
  { text: 'Hannah', sex: 'f' },
  { text: 'Hana', sex: 'f' },
  { text: 'Jáchym', sex: 'm' },
  { text: 'Joachim', sex: 'm' },
  { text: 'Petra', sex: 'f' },
  { text: 'Petronila', sex: 'f' },
  { text: 'Helena', sex: 'f' },
  { text: 'Ludvík', sex: 'm' },
  { text: 'Bernard', sex: 'm' },
  { text: 'Johana', sex: 'f' },
  { text: 'Bohuslav', sex: 'm' },
  { text: 'Božislav', sex: 'm' },
  { text: 'Sandra', sex: 'f' },
  { text: 'Bartolomej', sex: 'm' },
  { text: 'Bartoloměj', sex: 'm' },
  { text: 'Radim', sex: 'm' },
  { text: 'Radimír', sex: 'm' },
  { text: 'Luděk', sex: 'm' },
  { text: 'Otokar', sex: 'm' },
  { text: 'Otakar', sex: 'm' },
  { text: 'Augustýn', sex: 'm' },
  { text: 'Augustin', sex: 'm' },
  { text: 'Evelin', sex: 'm' },
  { text: 'Evelina', sex: 'f' },
  { text: 'Evelína', sex: 'f' },
  { text: 'Vladěna', sex: 'f' },
  { text: 'Paulína', sex: 'f' },
  { text: 'Pavlína', sex: 'f' },
  { text: 'Linda', sex: 'f' },
  { text: 'Samuel', sex: 'm' },
  { text: 'Adela', sex: 'f' },
  { text: 'Adléta', sex: 'f' },
  { text: 'Adéla', sex: 'f' },
  { text: 'Bronislav', sex: 'm' },
  { text: 'Henrieta', sex: 'f' },
  { text: 'Jindřiška', sex: 'f' },
  { text: 'Boris', sex: 'm' },
  { text: 'Boleslav', sex: 'm' },
  { text: 'Regína', sex: 'f' },
  { text: 'Regina', sex: 'f' },
  { text: 'Mariana', sex: 'f' },
  { text: 'Daniela', sex: 'f' },
  { text: 'Irma', sex: 'f' },
  { text: 'Denisa', sex: 'f' },
  { text: 'Denis', sex: 'm' },
  { text: 'Marie', sex: 'f' },
  { text: 'Lubor', sex: 'm' },
  { text: 'Radka', sex: 'f' },
  { text: 'Jolana', sex: 'f' },
  { text: 'Ludmila', sex: 'f' },
  { text: 'Naděžda', sex: 'f' },
  { text: 'Krištof', sex: 'm' },
  { text: 'Kryštof', sex: 'm' },
  { text: 'Zita', sex: 'f' },
  { text: 'Oleg', sex: 'm' },
  { text: 'Matouš', sex: 'm' },
  { text: 'Darina', sex: 'f' },
  { text: 'Berta', sex: 'f' },
  { text: 'Bertina', sex: 'f' },
  { text: 'Jaromír', sex: 'm' },
  { text: 'Zlata', sex: 'f' },
  { text: 'Andrea', sex: 'm' },
  { text: 'Ondřejka', sex: 'f' },
  { text: 'Jonáš', sex: 'm' },
  { text: 'Václav', sex: 'm' },
  { text: 'Václava', sex: 'm' },
  { text: 'Michael', sex: 'm' },
  { text: 'Michal', sex: 'm' },
  { text: 'Jeronym', sex: 'm' },
  { text: 'Jeroným', sex: 'm' },
  { text: 'Jarolím', sex: 'm' },
  { text: 'Igor', sex: 'm' },
  { text: 'Oliver', sex: 'm' },
  { text: 'Olivia', sex: 'f' },
  { text: 'Olívie', sex: 'f' },
  { text: 'Bohumil', sex: 'm' },
  { text: 'František', sex: 'm' },
  { text: 'Elsa', sex: 'f' },
  { text: 'Eliška', sex: 'f' },
  { text: 'Hanuš', sex: 'm' },
  { text: 'Justýna', sex: 'f' },
  { text: 'Justina', sex: 'f' },
  { text: 'Justin', sex: 'm' },
  { text: 'Věra', sex: 'f' },
  { text: 'Viera', sex: 'f' },
  { text: 'Štefan', sex: 'm' },
  { text: 'Sára', sex: 'f' },
  { text: 'Marina', sex: 'f' },
  { text: 'Marína', sex: 'f' },
  { text: 'Andrej', sex: 'm' },
  { text: 'Marcel', sex: 'm' },
  { text: 'Renata', sex: 'f' },
  { text: 'Renáta', sex: 'f' },
  { text: 'Agáta', sex: 'f' },
  { text: 'Tereza', sex: 'f' },
  { text: 'Havel', sex: 'm' },
  { text: 'Hedvika', sex: 'f' },
  { text: 'Lukáš', sex: 'm' },
  { text: 'Michala', sex: 'f' },
  { text: 'Michaela', sex: 'f' },
  { text: 'Vendelín', sex: 'm' },
  { text: 'Brigita', sex: 'f' },
  { text: 'Bridget', sex: 'f' },
  { text: 'Sabina', sex: 'f' },
  { text: 'Teodor', sex: 'm' },
  { text: 'Theodor', sex: 'm' },
  { text: 'Nina', sex: 'f' },
  { text: 'Beáta', sex: 'f' },
  { text: 'Beata', sex: 'f' },
  { text: 'Erik', sex: 'm' },
  { text: 'Ervín', sex: 'f' },
  { text: 'Šarlota', sex: 'f' },
  { text: 'Zoja', sex: 'f' },
  { text: 'Zoe', sex: 'f' },
  { text: 'Sylva', sex: 'f' },
  { text: 'Silva', sex: 'f' },
  { text: 'Silvie', sex: 'f' },
  { text: 'Tadeáš', sex: 'm' },
  { text: 'Stefanie', sex: 'f' },
  { text: 'Štepánka', sex: 'f' },
  { text: 'Felix', sex: 'm' },
  { text: 'Hubert', sex: 'm' },
  { text: 'Karel', sex: 'm' },
  { text: 'Miriam', sex: 'm' },
  { text: 'Liběna', sex: 'f' },
  { text: 'Saskie', sex: 'f' },
  { text: 'Bohumír', sex: 'm' },
  { text: 'Bohdan', sex: 'm' },
  { text: 'Eugen', sex: 'm' },
  { text: 'Evžen', sex: 'm' },
  { text: 'Martin', sex: 'm' },
  { text: 'Benedikt', sex: 'm' },
  { text: 'Tibor', sex: 'm' },
  { text: 'Sáva', sex: 'f' },
  { text: 'Leopold', sex: 'm' },
  { text: 'Otmar', sex: 'm' },
  { text: 'Otomar', sex: 'm' },
  { text: 'Mahulena', sex: 'f' },
  { text: 'Romana', sex: 'f' },
  { text: 'Alžběta', sex: 'f' },
  { text: 'Elisabeth', sex: 'f' },
  { text: 'Nikola', sex: 'f' },
  { text: 'Albert', sex: 'm' },
  { text: 'Cecílie', sex: 'f' },
  { text: 'Kliment', sex: 'm' },
  { text: 'Klement', sex: 'm' },
  { text: 'Emilia', sex: 'f' },
  { text: 'Emílie', sex: 'f' },
  { text: 'Katarína', sex: 'f' },
  { text: 'Katka', sex: 'f' },
  { text: 'Kateřina', sex: 'f' },
  { text: 'Artur', sex: 'm' },
  { text: 'Xenie', sex: 'f' },
  { text: 'Renée', sex: 'm' },
  { text: 'René', sex: 'm' },
  { text: 'Zina', sex: 'f' },
  { text: 'Ondřej', sex: 'm' },
  { text: 'Iva', sex: 'f' },
  { text: 'Blanka', sex: 'f' },
  { text: 'Svatoslav', sex: 'm' },
  { text: 'Světoslav', sex: 'm' },
  { text: 'Barbara', sex: 'f' },
  { text: 'Barbora', sex: 'f' },
  { text: 'Bára', sex: 'f' },
  { text: 'Jitka', sex: 'f' },
  { text: 'Mikoláš', sex: 'm' },
  { text: 'Nikolas', sex: 'm' },
  { text: 'Mikuláš', sex: 'm' },
  { text: 'Benjamin', sex: 'm' },
  { text: 'Ambrož', sex: 'm' },
  { text: 'Květoslava', sex: 'f' },
  { text: 'Vratislav', sex: 'm' },
  { text: 'Julie', sex: 'f' },
  { text: 'Juliana', sex: 'f' },
  { text: 'Julia', sex: 'f' },
  { text: 'Dana', sex: 'f' },
  { text: 'Šimona', sex: 'f' },
  { text: 'Simeona', sex: 'f' },
  { text: 'Simona', sex: 'f' },
  { text: 'Lucia', sex: 'f' },
  { text: 'Lucie', sex: 'f' },
  { text: 'Luciana', sex: 'f' },
  { text: 'Lýdie', sex: 'f' },
  { text: 'Lydia', sex: 'f' },
  { text: 'Lydie', sex: 'f' },
  { text: 'Radana', sex: 'f' },
  { text: 'Albína', sex: 'f' },
  { text: 'Daniel', sex: 'm' },
  { text: 'Dan', sex: 'm' },
  { text: 'Miloslav', sex: 'm' },
  { text: 'Ester', sex: 'f' },
  { text: 'Dagmara', sex: 'f' },
  { text: 'Dáša', sex: 'f' },
  { text: 'Dagmar', sex: 'f' },
  { text: 'Natálie', sex: 'f' },
  { text: 'Simon', sex: 'm' },
  { text: 'Simeon', sex: 'm' },
  { text: 'Šimon', sex: 'm' },
  { text: 'Vlasta', sex: 'f' },
  { text: 'Eva', sex: 'f' },
  { text: 'Adam', sex: 'm' },
  { text: 'Štepán', sex: 'm' },
  { text: 'Štěpán', sex: 'm' },
  { text: 'Žaneta', sex: 'f' },
  { text: 'Bohumila', sex: 'm' },
  { text: 'Judita', sex: 'f' },
  { text: 'David', sex: 'm' },
  { text: 'Silvester', sex: 'm' },
  { text: 'Silvestr', sex: 'm' },
  { text: 'Sylvestr', sex: 'm' },
];
